import { render, staticRenderFns } from "./PFForfeitureImport.vue?vue&type=template&id=f7a7f00e"
import script from "./PFForfeitureImport.vue?vue&type=script&lang=js"
export * from "./PFForfeitureImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports